import { render } from "./ServicesBlock.vue?vue&type=template&id=5db3b29a"
import script from "./ServicesBlock.vue?vue&type=script&lang=js"
export * from "./ServicesBlock.vue?vue&type=script&lang=js"

import "./ServicesBlock.vue?vue&type=style&index=0&id=5db3b29a&lang=scss"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__